module.exports = __webpack_public_path__ + "img/bolta-logo.c52a4d6b.jpg";